export const bitgetAccountCategory = 'bitget'

export const networkEvmChainIds: Record<string, number | undefined> = {
  ArbitrumOne: 42161,
  AstrEvm: 592,
  'AVAXC-Chain': 43114,
  BASE: 8453,
  BEP20: 56,
  BERA: 80094,
  ERC20: 1,
  ETH: 1,
  Fantom: 250,
  LINEA: 59144,
  MantaNetWork: 169,
  MetisToken: 1088,
  Moonbeam: 1284,
  MOVR: 1285,
  MNT: 5000,
  OASYS: 248,
  Optimism: 10,
  OPTIMISM: 10,
  POLYGON: 137,
  RONIN: 2020,
  SCROLL: 534352,
  SONIC: 146,
  TAIKO: 167000,
  zkSyncEra: 324,
}

export const networkPolkadotChainIds: Record<string, number | undefined> = {
  Astar: 2006,
  DOT: 0,
  MantaAtlantic: 2104,
  PolkadotAssetHub: 1000,
}

export const solanaNetwork = 'SOL'
